module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_smartwatch_1756ab87fc0363a577c470755ef4fbbf.png";